var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29_1184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2369 0L10.7629 0C7.02778 0 3.99988 3.02784 3.99988 6.76294V25.2369C3.99988 28.972 7.02778 32 10.7629 32H29.2369C32.972 32 35.9999 28.972 35.9999 25.2369V6.76294C35.9999 3.02784 32.972 0 29.2369 0Z",
    fill: "url(#paint0_linear_29_1184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 9C16.3673 9 16.2401 9.05268 16.1463 9.14645C16.0526 9.24021 15.9999 9.36739 15.9999 9.5V22.5C15.9999 22.5876 16.0229 22.6736 16.0666 22.7494C16.1103 22.8253 16.1732 22.8884 16.2489 22.9323C16.3247 22.9763 16.4106 22.9995 16.4982 22.9998C16.5857 23.0001 16.6718 22.9774 16.7479 22.934L19.9999 21.074L23.2519 22.934C23.3279 22.9774 23.414 23.0001 23.5016 22.9998C23.5891 22.9995 23.6751 22.9763 23.7508 22.9323C23.8265 22.8884 23.8894 22.8253 23.9331 22.7494C23.9768 22.6736 23.9998 22.5876 23.9999 22.5V9.5C23.9999 9.36739 23.9472 9.24021 23.8534 9.14645C23.7597 9.05268 23.6325 9 23.4999 9H16.4999ZM16.9999 10H22.9999V21.637L20.2479 20.064C20.1723 20.0209 20.0869 19.9982 19.9999 19.9982C19.9129 19.9982 19.8274 20.0209 19.7519 20.064L16.9999 21.637V10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29_1184",
    x: -0.00012207,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29_1184"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29_1184",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_1184",
    x1: 6.08858,
    y1: 0.426884,
    x2: 33.888,
    y2: 31.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF770B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveLogo);
export default __webpack_public_path__ + "static/media/saveLogo.363251dbf635c964c3200a20b32607e7.svg";
export { ForwardRef as ReactComponent };